import type { StandardSchemaV1 } from '@standard-schema/spec';
import type { Result } from '../types/result';

export const validate = <TInput, TOutput>(
    schema: StandardSchemaV1<TInput, TOutput>,
    value: unknown
): Result<TOutput> => {
    const validation = schema['~standard'].validate(value);

    if (validation instanceof Promise) {
        throw new Error(
            'validateSync must not be called with an async schema!'
        );
    }

    if (validation.issues) {
        return {
            success: false,
            error: validation.issues,
        };
    }

    return {
        success: true,
        data: validation.value,
    };
};

export const validateAsync = async <TInput, TOutput>(
    schema: StandardSchemaV1<TInput, TOutput>,
    value: unknown
): Promise<Result<TOutput>> => {
    const validation = await schema['~standard'].validate(value);

    if (validation.issues) {
        return {
            success: false,
            error: validation.issues,
        };
    }

    return {
        success: true,
        data: validation.value,
    };
};

export const validateUnsafe = <TInput, TOutput>(
    schema: StandardSchemaV1<TInput, TOutput>,
    value: unknown
): TOutput => {
    const validation = validate(schema, value);

    if (!validation.success) {
        throw validation.error;
    }

    return validation.data;
};
